/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_Case_DeliveredInputs */

const vi_station_voice_case_delivered = /** @type {(inputs: Station_Voice_Case_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao xong`)
};

/**

* @param {Station_Voice_Case_DeliveredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_case_delivered = /** @type {((inputs?: Station_Voice_Case_DeliveredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_Case_DeliveredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_case_delivered(inputs)
});